import axios from "axios";
import store from 'store';
import history from './history';

var authToken;
var authUser;
const AUTH_TOKEN_STORAGE_TAG = 'cke-auth';

const saveAuthTokenToStorage = (authObject) => {
  //save AuthTokens to storage
  store.set(AUTH_TOKEN_STORAGE_TAG, authObject);
  console.log('persisted auth to local storage', authObject);

  //also save locally
  authToken = authObject.authToken;
  authUser = authObject.authUser;

  return authObject;
}

const loadAuthTokenFromStorage = () => {
  //Load tokens from storage
  const authObject = store.get(AUTH_TOKEN_STORAGE_TAG);
  if (authObject) {
    authToken = authObject.authToken;
    authUser = authObject.authUser;

    console.log('retrieved auth from local storage', authObject);

    return authObject;
  } else {
    console.log('Tokens not available in local storage');
  };
}

const clearAuthTokenFromStorage = async() => {
  //Load tokens from storage
  store.remove(AUTH_TOKEN_STORAGE_TAG);
}

const axiosInstance = axios.create({
  //baseURL: "http://127.0.0.1:3000",
  //baseURL: "https://krm70rei6b.execute-api.eu-west-3.amazonaws.com/Prod/",
  baseURL: '../../api/',
  headers: {
    "Content-type": "application/json"
  }
});

const responseSuccessHandler = response => {
  return response;
};

const responseErrorHandler = error => {
  if (error.response.status === 401) {
    clearAuthTokenFromStorage();
    authToken = null; authUser = null;

    //history.replace('/login');
    window.location = '/login';

    return;
  }

  return Promise.reject(error);
};

axiosInstance.interceptors.response.use(
  response => responseSuccessHandler(response),
  error => responseErrorHandler(error)
);


axiosInstance.interceptors.request.use(config => {
  if (authToken) {
    config.headers.common['authtoken'] = authToken;
  }
  if (authUser) {
    config.headers.common['authuser'] = authUser;
  }
  return config;
});

const AxiosWrapper = {
  http: axiosInstance,
  loadAuthTokenFromStorage,
  clearAuthTokenFromStorage,
  saveAuthTokenToStorage,
};

export default AxiosWrapper;